import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export function cn(...parts: Array<string | false | null | undefined>) {
  return twMerge(parts.filter(Boolean).join(' '));
}

export function hasRenderableNode(node: ReactNode) {
  return node !== undefined && node !== null && typeof node !== 'boolean';
}

export function hasNonEmptyRenderableNode(node: ReactNode) {
  if (typeof node === 'string') return node.trim().length > 0;
  return hasRenderableNode(node);
}
